import { Create, useFileUploadState } from "@refinedev/antd";

// It is recommended to use explicit import as seen below to reduce bundle size.
// import { IconName } from "@ant-design/icons";
import * as Icons from "@ant-design/icons";

import { Button, Divider, message, Tag, Upload } from "antd";
import { useApiUrl } from "@refinedev/core";

export const UploadFetchPermitsPage: React.FC = () => {
  const { isLoading, onChange } = useFileUploadState();
  const apiUrl = useApiUrl();

  const props = {
    name: "file",
    multiple: false,
    maxCount: 1,
    action: `${apiUrl}/upload/permits/fetch`,
    onChange(info: { file: { name?: any; status?: any }; fileList: any }) {
      const { status } = info.file;
      if (status !== "uploading") {
        //do nothing
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e: { dataTransfer: { files: any } }) {
      //do nothing
    },
  };

  return (
    <Create
      breadcrumb={false}
      title="Fetch Permits"
      headerProps={{
        // onBack: () => window.history.back(),
        subTitle: "fetch permits from UKHO",
        ghost: true,
        footer: (
          <Divider plain>
            © {new Date().getFullYear()} e-Mariner NavSolutions
          </Divider>
        ),
        tags: isLoading ? (
          <Tag color="orange">loading</Tag>
        ) : (
          <Tag color="green">live</Tag>
        ),
      }}
      footerButtons={
        <Button type="primary" disabled hidden>
          Upload
        </Button>
      }
      // saveButtonProps={{
      //   ...saveButtonProps,
      //   disabled: isLoading,
      //   // icon: <Icons.UploadOutlined />,
      //   onClick: () => console.log("save button clicked..."),
      // }}
    >
      <Upload.Dragger {...props} listType="picture">
        <p className="ant-upload-drag-icon">
          <Icons.InboxOutlined />
        </p>
        <p className="ant-upload-text">
          Click or drag & drop file to this area to upload
        </p>
        <p className="ant-upload-hint">
          Support for a single upload of CSV file for fetching latest UKHO
          permits.
        </p>
      </Upload.Dragger>
    </Create>
  );
};
